/**
 * Take an input of any type.
 * Return if it is a true value or contains a true value.
 * If it's an array, check is at least one array item contains true.
 * If it's an object, check is at least one object value contains true.
 *
 * Used in nested form values to determine if a value with nested children has at least one of their nested children in a dirty state.
 */
export const checkTrueRecursively = (object: unknown): boolean => {
  if (object === true) return true

  if (object === null || object === undefined) return false
  if (Array.isArray(object)) return object.some(item => checkTrueRecursively(item))
  if (typeof object === 'object') return Object.values(object).some(item => checkTrueRecursively(item))

  return false
}
